// Auto-import SASS generated CSS
import './index.css';

export {default as Accordion, AccordionProps} from './Accordion';
export {default as FAQAccordion, FAQAccordionProps} from './faqAccordion';
export {default as default} from './Accordion';
